<template>
  <div class="help">
    <div class="help-list">
      <div v-for="(help, i) in helps" class="help-item" :key="i" :id="'help' + (i + 1)">
        <div class="help-item-left">{{JSON.parse(help.config).step}}</div>
        <div class="help-item-center">
          <img :src="'http://tarzan.minus.live' + help.img" />
          <div class="help-item-center-info">
            <span>{{help.name}}</span>
            <span class="desc">{{JSON.parse(help.config).en}}</span>
          </div>
        </div>
        <div class="help-item-right">
          <div class="help-item-right-header">
            <span v-for="(desc, j) in JSON.parse(help.config).descArr" :key="'desc' + i + j">{{desc}}</span>
          </div>
          <div class="help-item-right-content">
            <div class="help-item-right-content-scroll" :style="getStyle('scroll' + i, help.id)">
              <div v-for="(nav, k) in filterNavs(help.id)" :key="'nav' + k">
                <div v-for="(row, l) in nav" :key="'row' + k + l" class="help-item-row">
                  <div v-for="(col, m) in row" :key="'col' + i + k + l + m" class="help-item-col">
                    <img :src="'http://tarzan.minus.live' + col.img" />
                    <span>{{col.name}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="help-item-right-content-navs">
              <div
                v-for="(nav, k) in filterNavs(help.id)"
                :key="'nav' + i + k"
                :class="getNavClass('scroll' + i, k)"
                @click="setNav('scroll' + i, k)"></div>
            </div>
          </div>
          <div class="more" @click="showBoard">详细了解</div>
        </div>
      </div>
    </div>

    <div class="item">
      <div class="item-header">
        <div class="item-header-title">OUR CUSTOMERS</div>
        <div class="item-header-name">
          <span class="item-header-name-line" />
          <span>服务</span>
          <span class="bold">案例</span>
          <span class="item-header-name-line" />
        </div>
        <div class="item-header-desc">值得信赖的专业数据中心技术服务提供商</div>
      </div>

      <div class="item-content">
        <Message />
      </div>
    </div>
  </div>
</template>

<script>
import Message from '../../components/Message'
import Img1 from '../../assets/images/help/img1.png'
import Img2 from '../../assets/images/help/img2.png'
import Img3 from '../../assets/images/help/img3.png'
import Img4 from '../../assets/images/help/img4.png'
import Img5 from '../../assets/images/help/img5.png'

import Icon11 from '../../assets/images/help/icon-1-1.png'
import Icon12 from '../../assets/images/help/icon-1-2.png'
import Icon13 from '../../assets/images/help/icon-1-3.png'
import Icon14 from '../../assets/images/help/icon-1-4.png'

import Icon21 from '../../assets/images/help/icon-2-1.png'
import Icon22 from '../../assets/images/help/icon-2-2.png'
import Icon23 from '../../assets/images/help/icon-2-3.png'
import Icon24 from '../../assets/images/help/icon-2-4.png'
import Icon25 from '../../assets/images/help/icon-2-5.png'
import Icon26 from '../../assets/images/help/icon-2-6.png'
import Icon27 from '../../assets/images/help/icon-2-7.png'
import Icon28 from '../../assets/images/help/icon-2-8.png'
import Icon29 from '../../assets/images/help/icon-2-9.png'
import Icon210 from '../../assets/images/help/icon-2-10.png'
import Icon211 from '../../assets/images/help/icon-2-11.png'

import Icon31 from '../../assets/images/help/icon-3-1.png'
import Icon32 from '../../assets/images/help/icon-3-2.png'
import Icon33 from '../../assets/images/help/icon-3-3.png'
import Icon34 from '../../assets/images/help/icon-3-4.png'
import Icon35 from '../../assets/images/help/icon-3-5.png'
import Icon36 from '../../assets/images/help/icon-3-6.png'
import Icon37 from '../../assets/images/help/icon-3-7.png'

import Icon41 from '../../assets/images/help/icon-4-1.png'
import Icon42 from '../../assets/images/help/icon-4-2.png'
import Icon43 from '../../assets/images/help/icon-4-3.png'
import Icon44 from '../../assets/images/help/icon-4-4.png'
import Icon45 from '../../assets/images/help/icon-4-5.png'
import Icon46 from '../../assets/images/help/icon-4-6.png'
import Icon47 from '../../assets/images/help/icon-4-7.png'

import Icon51 from '../../assets/images/help/icon-5-1.png'
import Icon52 from '../../assets/images/help/icon-5-2.png'
import Icon53 from '../../assets/images/help/icon-5-3.png'

import { getHelpList, getTabList } from '../../services'
import _ from 'lodash'

export default {
  components: {
    Message
  },

  data () {
    return {
      Img1,
      Img2,
      Img3,
      Img4,
      Img5,
      Icon11,
      Icon12,
      Icon13,
      Icon14,
      Icon21,
      Icon22,
      Icon23,
      Icon24,
      Icon25,
      Icon26,
      Icon27,
      Icon28,
      Icon29,
      Icon210,
      Icon211,
      Icon31,
      Icon32,
      Icon33,
      Icon34,
      Icon35,
      Icon36,
      Icon37,
      Icon41,
      Icon42,
      Icon43,
      Icon44,
      Icon45,
      Icon46,
      Icon47,
      Icon51,
      Icon52,
      Icon53,
      scroll0: 0,
      scroll1: 0,
      scroll2: 0,
      scroll3: 0,
      scroll4: 0,
      tabs: [],
      helps: []
    }
  },

  methods: {
    showBoard () {
      window.eventBus.$emit('boardShow')
    },

    getStyle (key, id) {
      const len = this.filterNavs(id).length
      return {
        transform: `translate(${this[key] * -(100 / len)}%)`
      }
    },

    getNavClass (key, value) {
      return this[key] == value ? 'active' : ''
    },

    setNav (key, val) {
      this[key] = val
    },

    filterNavs (id) {
      const navs = this.tabs.filter(item => item.desc === 'help' + id)
      return _.chunk(_.chunk(navs, 3), 2)
    }
  },

  created () {
    getTabList().then(res => {
      this.tabs = res.data.data.data.children
    })
    getHelpList().then(res => {
      this.helps = res.data.data.data.children
    })
  }
}
</script>

<style lang="less" scoped>
.help {
  background: #e7e7e7;
  &-list {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &-item {
    width: 960px;
    height: 220px;
    display: flex;
    margin: 20px 0px;
    background: #fff;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 1280px;
      height: 260px;
    }
          
    @media screen and (min-width: 1920px){
      width: 1680px;
      height: 300px;
    }

    &-left {
      width: 13px;
      height: 100%;
      color: #fff;
      background: #000;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 9px;

      @media (min-width: 1280px) and (max-width: 1680px){
        width: 17px;
        font-size: 12px;
      }
            
      @media screen and (min-width: 1920px){
        width: 21px;
        font-size: 15px;
      }
    }
    &-center {
      width: 293px;
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      @media (min-width: 1280px) and (max-width: 1680px){
        width: 393px;
      }
            
      @media screen and (min-width: 1920px){
        width: 493px;
      }

      img {
        width: 293px;
        height: 100%;

        @media (min-width: 1280px) and (max-width: 1680px){
          width: 393px;
        }
              
        @media screen and (min-width: 1920px){
          width: 493px;
        }
      }

      &-info {
        position: absolute;
        padding: 20px;
        background: #000;
        color: #fff;
        display: flex;
        flex-direction: column;

        @media (min-width: 1280px) and (max-width: 1680px){
          padding: 27px;
        }
              
        @media screen and (min-width: 1920px){
          padding: 34px;
        }

        .desc {
          font-size: 9px;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 12px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 15px;
          }
        }
      }
    }

    &-right {
      flex: 1;
      position: relative;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 654px;
      &-header {
        font-size: 8px;
        display: flex;
        flex-direction: column;
        padding: 10px 0px;

        @media (min-width: 1280px) and (max-width: 1680px){
          font-size: 12px;
          padding: 13px 0px;
        }
              
        @media screen and (min-width: 1920px){
          font-size: 15px;
          padding: 16px 0px;
        }
      }

      &-content {
        position: relative;
        margin-top: 10px;
        display: flex;
        overflow: hidden;
        width: 641px;
        min-height: 119px;

        @media (min-width: 1280px) and (max-width: 1680px){
          width: 845px;
          margin-top: 13px;
          min-height: 147px;
        }
              
        @media screen and (min-width: 1920px){
          width: 1061px;
          margin-top: 13px;
          min-height: 171px;
        }

        &-scroll {
          display: flex;
          flex-wrap: nowrap;
          transition: all .5s ease-in-out;
        }

        &-navs {
          position: absolute;
          bottom: 0px;
          display: flex;
          justify-content: center;
          width: 100%;

          > div {
            width: 40px;
            height: 2px;
            background: #919191;
            margin-right: 8px;
            cursor: pointer;
          }

          .active {
            background: #000;
          }
        }
      }

      .more {
        position: absolute;
        bottom: 5px;
        width: 96px;
        height: 28px;
        border-radius: 14px;
        background-color: #f45937;
        color: #fff;
        font-size: 9px;
        line-height: 28px;
        text-align: center;
        cursor: pointer;
      }


      @media (min-width: 1280px) and (max-width: 1680px){
        width: 870px;
      }
            
      @media screen and (min-width: 1920px){
        width: 1166px;
      }
    }

    &-row {
      display: flex;
      height: 60px;

      @media (min-width: 1280px) and (max-width: 1680px){
        height: 73px;
      }
            
      @media screen and (min-width: 1920px){
        height: 85px;
      }

      .help-item-col:last-child {
        border-right: 0px dashed #919191;
      }
    }

    &-col {
      padding: 8px 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-bottom: 1px dashed #919191;
      border-right: 1px dashed #919191;
      font-size: 9px;
      width: 181px;

      @media (min-width: 1280px) and (max-width: 1680px){
        padding: 10px 20px;
        font-size: 12px;
        width: 241px;
      }
            
      @media screen and (min-width: 1920px){
        padding: 10px 26px;
        font-size: 15px;
        width: 301px;
      }

      img {
        width: 18px;
        height: 18px;
        padding-bottom: 8px;

        @media (min-width: 1280px) and (max-width: 1680px){
          width: 24px;
          height: 24px;
          padding-bottom: 12px;
        }
              
        @media screen and (min-width: 1920px){
          width: 30px;
          height: 30px;
          padding-bottom: 14px;
        }
      }
    }

    &-row:last-child {
      .help-item-col {
        border-bottom: 0px dashed #919191;;
      }
    }
  }

  .item {
      padding-top: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #fff;

      @media (min-width: 1280px) and (max-width: 1680px){
        padding-top: 120px;
      }
            
      @media screen and (min-width: 1920px){
        padding-top: 160px;
      }

      &-header {
        &-title {
          color: rgba(34, 34, 34, .1);
          font-size: 15px;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 22.5px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 30px;
          }
        }

        &-name {
          font-size: 24px;
          padding: 4px 0px;
          display: flex;
          align-items: center;
          justify-content: center;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 36px;
            padding: 6px 0px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 48px;
            padding: 8px 0px;
          }

          &-line {
            width: 60px;
            height: 2px;
            background: rgba(34, 34, 34, .1);
            display: inline-block;
            margin: 0px 16px;

            @media (min-width: 1280px) and (max-width: 1680px){
              width: 90px;
              height: 3px;
              margin: 0px 24px;
            }
                  
            @media screen and (min-width: 1920px){
              width: 120px;
              height: 4px;
              margin: 0 32px;
            }
          }
          .bold {
            font-weight: bold;
          }
        }

        &-desc {
          color: #959595;
          font-size: 9px;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 13.5px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 18px;
          }
        }
      }

      &-content {
        margin-top: 20px;
        width: 100%;

        @media (min-width: 1280px) and (max-width: 1680px){
          margin-top: 30px;
        }
              
        @media screen and (min-width: 1920px){
          margin-top: 40px;
        }
      }
    }
}
</style>